import React from 'react';
import { Navigate } from 'react-router-dom';
import PublicLayout from './layouts/PublicLayout';
import MainLayout from './layouts/MainLayout';
import DocumentListView from './views/document/DocumentListView';
import DocumentForm from './views/document/DocumentFormView';
import DocumentPreview from './views/document/DocumentPreviewView';
import FolderForm from './views/document/FolderFormView';
import UsersView from './views/user/UsersView';
import NotFoundView from './views/errors/NotFoundView';
import LoginView from './views/auth/LoginView';
import ManagementLayout from './layouts/ManagementLayout';
import NewsListView from './views/news/NewsListView';
import PassActivationView from './views/auth/PassActivationView';
import DictionairesView from './views/admin/DictionairesView';
import SideRepresentedForm from './views/admin/DictionairesView/SideRepresentedForm';
import InstytutionForm from './views/admin/DictionairesView/InstytutionForm';
import FunctionForm from './views/admin/DictionairesView/FunctionForm';
import WorkingGroupForm from './views/admin/DictionairesView/WorkingGroupForm';
import AnswerOptionForm from './views/admin/DictionairesView/AnswerOptionForm';
import MessageTypeForm from './views/admin/DictionairesView/MessageTypeForm';
import ProfilesView from './views/user/ProfilesView';
import ProfileForm from './views/user/ProfileForm';
import UserForm from './views/user/UserForm';
import NewsForm from './views/news/NewsForm';
import NewsPreviewForm from './views/news/NewsPreviewForm';
import VotingManagementForm from './views/votingmanagment/VotingManagementForm';
import VotingsListView from './views/voting/VotingsListView';
import VotingForm from './views/voting/VotingForm';
import VotingManagementPreviewForm from './views/votingmanagment/VotingManagementPreviewForm';
import VotingsPreparingView from './views/votingmanagment/VotingsManagementListView/VotingsPreparingView';
import VotingsInProgressView from './views/votingmanagment/VotingsManagementListView/VotingsInProgressView';
import VotingsFinishedView from './views/votingmanagment/VotingsManagementListView/VotingsFinishedView';
import VotingsCanceledView from './views/votingmanagment/VotingsManagementListView/VotingsCanceledView';
import CalendarTabView from './views/calendar/CalendarTabView';
import MailingForm from './views/mailing/MailingForm';
import MailingsView from './views/mailing/MailingsView';
import MailingPreviewForm from './views/mailing/MailingPreviewForm';
import MailingEditForm from './views/mailing/MailingEditForm';
import AttendancePreviewForm from './views/document/AttendancePreviewForm';
import LicenceView from './views/auth/LicenceView';
import PolicyView from './views/auth/PolicyView';
import EmailConfigurationForm from './views/admin/EmailConfigurationForm';
import NewsAdminPreviewForm from './views/news/NewsAdminPreviewForm';
import VotingManagementVoteForm from './views/votingmanagment/VotingManagementVoteForm';
import DocumentFormUploadView from './views/document/DocumentFormUploadView';
import AttendanceManagementEditForm from './views/document/AttendanceManagementEditForm';
import ConfirmAttendanceLink from './views/auth/ConfirmAttendanceLink';
import MyAccountPreviewView from './views/auth/MyAccountPreviewView';
import MyAccountPasswordForm from './views/auth/MyAccountPasswordForm';
import EventLogView from './views/admin/EventLogView';
import IllegalAccess from './views/admin/IllegalAccess';
import LoggedInUsers from './views/admin/LoggedInUsers';
import NotAccessView from './views/auth/NotAccessView';
import EventForm from './views/calendar/CalendarTabView/EventForm';
import ContactForm from './views/help/ContactForm';
import HelpView from './views/help/HelpView';
import AccessibilityDeclaration from './views/auth/AccessibilityDeclaration';
import AccessibilityView from './views/help/AccessibilityView';
import CookiesPolicyView from './views/help/CookiesPolicyView';
import InformationClauseView from './views/help/InformationClauseView';
import LicenceLogView from './views/help/LicenceLogView';
import MoveForm from './views/document/MoveFormView';
import DeclarationTasksView from './views/auth/DeclarationTasksView';

export const routesPublicVoting = [
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { path: '/', element: <Navigate to="/aktualnosci" /> },
      { path: 'aktualnosci', element: <NewsListView /> },
      { path: 'aktualnosci/strona/:pageId/:rowsCount', element: <NewsListView /> },
      { path: 'aktualnosci/artykul/:entryId', element: <NewsPreviewForm /> },
      { path: 'aktualnosci/artykul/:entryId/:returnId', element: <NewsPreviewForm /> },
      { path: 'aktualnosci/artykul/:entryId/:returnId/:pageCount', element: <NewsPreviewForm /> },
      { path: 'dokumenty', element: <DocumentListView /> },
      { path: 'dokumenty/:folderId', element: <DocumentListView /> },
      { path: 'dokumentyglosowanie/:folderId/:votingId', element: <DocumentListView /> },
      { path: 'dokumenty/:folderId/:documentId', element: <DocumentListView /> },
      { path: 'dokumenty/dokument/:documentId', element: <DocumentPreview /> },
      { path: 'kalendarz', element: <CalendarTabView /> },
      { path: 'glosowania', element: <VotingsListView /> },
      { path: 'glosowania/:tabId', element: <VotingsListView /> },
      { path: 'pomoc/deklaracjadostepnosc', element: <AccessibilityView /> },
      { path: 'pomoc/politykaprywatnosci', element: <CookiesPolicyView /> },
      { path: 'pomoc/klauzulaobinf', element: <InformationClauseView /> },
      { path: 'pomoc/licencja', element: <LicenceLogView /> }
    ]
  },
  {
    path: '/',
    element: <ManagementLayout />,
    children: [
      { path: 'mojekonto', element: <MyAccountPreviewView /> },
      { path: 'zmianahasla', element: <MyAccountPasswordForm /> },
      { path: 'glosowanie/:votingEntryId', element: <VotingForm /> },
      { path: 'aktualnosci/nowyart', element: <NewsForm kmaction="new"/> },
      { path: 'aktualnosci/:tabId', element: <NewsListView /> },
      { path: 'aktualnosci/edytujart/:entryId', element: <NewsForm kmaction="edit"/> },
      { path: 'aktualnosci/podglad/:entryId', element: <NewsAdminPreviewForm /> },
      { path: 'nowydokument/:parentFolderId', element: <DocumentForm kmaction="new"/> },
      { path: 'kalendarz/nowewydarzenie', element: <EventForm kmaction="new"/> },
      { path: 'kalendarz/edycjawydarzenia/:entryId', element: <EventForm kmaction="edit"/> },
      { path: 'kalendarz/:tabId', element: <CalendarTabView /> },
      { path: 'nowydokument/:parentFolderId/:siblingDocumentId', element: <DocumentForm kmaction="new"/> },
      { path: 'nowydokument/:parentFolderId/:siblingDocumentId/:siblingDocumentName', element: <DocumentForm kmaction="new"/> },
      { path: 'dodajwieledok/:parentFolderId', element: <DocumentFormUploadView kmaction="new"/> },
      { path: 'dodajwieledok/:parentFolderId/:siblingDocumentId', element: <DocumentFormUploadView kmaction="new"/> },
      { path: 'dodajwieledok/:parentFolderId/:siblingDocumentId/:siblingDocumentName', element: <DocumentFormUploadView kmaction="new"/> },
      { path: 'edytujdokument/:documentId', element: <DocumentForm kmaction="edit"/> },
      { path: 'edytujdokument/:documentId/:siblingDocumentId', element: <DocumentForm kmaction="edit"/> },
      { path: 'edytujdokument/:documentId/:siblingDocumentId/:siblingDocumentName', element: <DocumentForm kmaction="edit"/> },
      { path: 'powiadomieniedokumenty/:folderId', element: <MailingForm kmcontext="document"/> },
      { path: 'powiadomienieglosowania/:votingId', element: <MailingForm kmcontext="voting"/> },
      { path: 'powiadomienieaktualnosci/:newsId', element: <MailingForm kmcontext="news"/> },
      { path: 'potwierdzeniaudzialu/:entryId', element: <AttendancePreviewForm /> },
      { path: 'potwierdzeniaudzialu/edycjapotwierdzenia/:entryId', element: <AttendanceManagementEditForm /> },
      { path: 'powiadomienia', element: <MailingsView /> },
      { path: 'powiadomienia/podgladpowiadomienia/:entryId', element: <MailingPreviewForm /> },
      { path: 'powiadomienia/edycjapowiadomienia/:entryId', element: <MailingEditForm /> },
      { path: 'nowykatalog/:parentFolderId', element: <FolderForm kmaction="new"/> },
      { path: 'nowykatalog/:parentFolderId/:siblingDocumentId', element: <FolderForm kmaction="new"/> },
      { path: 'nowykatalog/:parentFolderId/:siblingDocumentId/:siblingDocumentName', element: <FolderForm kmaction="new"/> },
      { path: 'edytujkatalog/:folderId', element: <FolderForm kmaction="edit"/> },
      { path: 'edytujkatalog/:folderId/:siblingDocumentId', element: <FolderForm kmaction="edit"/> },
      { path: 'edytujkatalog/:folderId/:siblingDocumentId/:siblingDocumentName', element: <FolderForm kmaction="edit"/> },
      { path: 'przenieskatalogdokument/:parentFolderId', element: <MoveForm/> },
      { path: 'uzytkownicy', element: <UsersView /> },
      { path: 'uzytkownicy/nowyuzytk', element: <UserForm kmaction="new"/> },
      { path: 'uzytkownicy/edytujuzytk/:entryId', element: <UserForm kmaction="edit"/> },
      { path: 'uzytkownicy/edytujuzytk/:entryId/:sortCol/:sortDir/:rowsPerPage/:page', element: <UserForm kmaction="edit"/> },
      { path: 'profile', element: <ProfilesView /> },
      { path: 'profile/nowyprofil', element: <ProfileForm kmaction="new"/> },
      { path: 'profile/edytujprofil/:entryId', element: <ProfileForm  kmaction="edit"/> },
      { path: 'administracja/slowniki', element: <DictionairesView /> },
      { path: 'administracja/slowniki/:tabId', element: <DictionairesView /> },
      { path: 'administracja/slowniki/nowareprstr', element: <SideRepresentedForm  kmaction="new"/> },
      { path: 'administracja/slowniki/edytujreprstr/:entryId', element: <SideRepresentedForm  kmaction="edit"/> },
      { path: 'administracja/slowniki/nowainst', element: <InstytutionForm  kmaction="new"/> },
      { path: 'administracja/slowniki/edytujinst/:entryId', element: <InstytutionForm  kmaction="edit"/> },
      { path: 'administracja/slowniki/nowafunk', element: <FunctionForm  kmaction="new"/> },
      { path: 'administracja/slowniki/edytujfunk/:entryId', element: <FunctionForm  kmaction="edit"/> },
      { path: 'administracja/slowniki/nowagruparob', element: <WorkingGroupForm  kmaction="new"/> },
      { path: 'administracja/slowniki/edytujgruparob/:entryId', element: <WorkingGroupForm  kmaction="edit"/> },
      { path: 'administracja/slowniki/nowywariantodp', element: <AnswerOptionForm  kmaction="new"/> },
      { path: 'administracja/slowniki/edytujwariantodp/:entryId', element: <AnswerOptionForm  kmaction="edit"/> },
      { path: 'administracja/slowniki/nowytypwiad', element: <MessageTypeForm kmaction="new"/> },
      { path: 'administracja/slowniki/edytujtypwiad/:entryId', element: <MessageTypeForm  kmaction="edit"/> },
      { path: 'administracja/sekretariatkm', element: <EmailConfigurationForm /> },
      { path: 'administracja/zdarzenia', element: <EventLogView /> },
      { path: 'administracja/nieuprawnionydostep', element: <IllegalAccess /> },
      { path: 'administracja/zalogowaniuzytkownicy', element: <LoggedInUsers /> },
      { path: 'zarzadzanieglosowania', element: <VotingsPreparingView /> },
      { path: 'zarzadzanieglosowania/wprzygotowaniu', element: <VotingsPreparingView /> },
      { path: 'zarzadzanieglosowania/wtrakcie', element: <VotingsInProgressView/> },
      { path: 'zarzadzanieglosowania/zakonczone', element: <VotingsFinishedView /> },
      { path: 'zarzadzanieglosowania/anulowane', element: <VotingsCanceledView /> },
      { path: 'zarzadzanieglosowania/noweglosowanie', element: <VotingManagementForm kmaction="new"/> },
      { path: 'zarzadzanieglosowania/edycjaglosowania/:entryId', element: <VotingManagementForm kmaction="edit"/> },
      { path: 'zarzadzanieglosowania/podgladglosowania/:entryId', element: <VotingManagementPreviewForm /> },
      { path: 'zarzadzanieglosowania/podgladglosowania/:entryId/:viewId', element: <VotingManagementPreviewForm /> },
      { path: 'zarzadzanieglosowania/edycjaglosu/:entryId', element: <VotingManagementVoteForm /> },
      { path: 'pomoc/pliki', element: <HelpView /> },
      { path: 'pomoc/kontakt', element: <ContactForm /> },
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'logowanie', element: <LoginView /> },
      { path: 'logowanie/:passwordChangeKey', element: <LoginView /> },
      { path: 'licencja', element: <LicenceView /> },
      { path: 'politykabezp', element: <PolicyView /> },
      { path: 'deklaracjazadaniacz', element: <DeclarationTasksView kmcontext="member"/> },
      { path: 'deklaracjazadaniaobs', element: <DeclarationTasksView kmcontext="observer"/> },
      { path: 'deklaracjadostepnosc', element: <AccessibilityDeclaration /> },
      { path: 'nieuprawnionydostep', element: <NotAccessView /> },
      { path: 'aktywacjahasla/:activationKey', element: <PassActivationView /> },
      { path: 'potwierdzenia/udzial/:confirmationKey', element: <ConfirmAttendanceLink action="participation"/> },
      { path: 'potwierdzenia/brakudzialu/:confirmationKey', element: <ConfirmAttendanceLink action="no_participation"/> },
      { path: '*', element: <NotFoundView /> }
    ]
  }
];

export const routes = [
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { path: '/', element: <Navigate to="/aktualnosci" /> },
      { path: 'aktualnosci', element: <NewsListView /> },
      { path: 'aktualnosci/strona/:pageId/:rowsCount', element: <NewsListView /> },
      { path: 'aktualnosci/artykul/:entryId', element: <NewsPreviewForm /> },
      { path: 'aktualnosci/artykul/:entryId/:returnId', element: <NewsPreviewForm /> },
      { path: 'aktualnosci/artykul/:entryId/:returnId/:pageCount', element: <NewsPreviewForm /> },
      { path: 'dokumenty', element: <DocumentListView /> },
      { path: 'dokumenty/:folderId', element: <DocumentListView /> },
      { path: 'dokumentyglosowanie/:folderId/:votingId', element: <DocumentListView /> },
      { path: 'dokumenty/:folderId/:documentId', element: <DocumentListView /> },
      { path: 'dokumenty/dokument/:documentId', element: <DocumentPreview /> },
      { path: 'kalendarz', element: <CalendarTabView /> },
      { path: 'pomoc/deklaracjadostepnosc', element: <AccessibilityView /> },
      { path: 'pomoc/politykaprywatnosci', element: <CookiesPolicyView /> },
      { path: 'pomoc/klauzulaobinf', element: <InformationClauseView /> },
      { path: 'pomoc/licencja', element: <LicenceLogView /> }
    ]
  },
  {
    path: '/',
    element: <ManagementLayout />,
    children: [
      { path: 'mojekonto', element: <MyAccountPreviewView /> },
      { path: 'zmianahasla', element: <MyAccountPasswordForm /> },
      { path: 'glosowania', element: <VotingsListView /> },
      { path: 'glosowania/:tabId', element: <VotingsListView /> },
      { path: 'glosowanie/:votingEntryId', element: <VotingForm /> },
      { path: 'aktualnosci/nowyart', element: <NewsForm kmaction="new"/> },
      { path: 'aktualnosci/:tabId', element: <NewsListView /> },
      { path: 'aktualnosci/edytujart/:entryId', element: <NewsForm kmaction="edit"/> },
      { path: 'aktualnosci/podglad/:entryId', element: <NewsAdminPreviewForm /> },
      { path: 'nowydokument/:parentFolderId', element: <DocumentForm kmaction="new"/> },
      { path: 'kalendarz/nowewydarzenie', element: <EventForm kmaction="new"/> },
      { path: 'kalendarz/edycjawydarzenia/:entryId', element: <EventForm kmaction="edit"/> },
      { path: 'kalendarz/:tabId', element: <CalendarTabView /> },
      { path: 'nowydokument/:parentFolderId/:siblingDocumentId', element: <DocumentForm kmaction="new"/> },
      { path: 'nowydokument/:parentFolderId/:siblingDocumentId/:siblingDocumentName', element: <DocumentForm kmaction="new"/> },
      { path: 'dodajwieledok/:parentFolderId', element: <DocumentFormUploadView kmaction="new"/> },
      { path: 'dodajwieledok/:parentFolderId/:siblingDocumentId', element: <DocumentFormUploadView kmaction="new"/> },
      { path: 'dodajwieledok/:parentFolderId/:siblingDocumentId/:siblingDocumentName', element: <DocumentFormUploadView kmaction="new"/> },
      { path: 'edytujdokument/:documentId', element: <DocumentForm kmaction="edit"/> },
      { path: 'edytujdokument/:documentId/:siblingDocumentId', element: <DocumentForm kmaction="edit"/> },
      { path: 'edytujdokument/:documentId/:siblingDocumentId/:siblingDocumentName', element: <DocumentForm kmaction="edit"/> },
      { path: 'powiadomieniedokumenty/:folderId', element: <MailingForm kmcontext="document"/> },
      { path: 'powiadomienieglosowania/:votingId', element: <MailingForm kmcontext="voting"/> },
      { path: 'powiadomienieaktualnosci/:newsId', element: <MailingForm kmcontext="news"/> },
      { path: 'potwierdzeniaudzialu/:entryId', element: <AttendancePreviewForm /> },
      { path: 'potwierdzeniaudzialu/edycjapotwierdzenia/:entryId', element: <AttendanceManagementEditForm /> },
      { path: 'powiadomienia', element: <MailingsView /> },
      { path: 'powiadomienia/podgladpowiadomienia/:entryId', element: <MailingPreviewForm /> },
      { path: 'powiadomienia/edycjapowiadomienia/:entryId', element: <MailingEditForm /> },
      { path: 'nowykatalog/:parentFolderId', element: <FolderForm kmaction="new"/> },
      { path: 'nowykatalog/:parentFolderId/:siblingDocumentId', element: <FolderForm kmaction="new"/> },
      { path: 'nowykatalog/:parentFolderId/:siblingDocumentId/:siblingDocumentName', element: <FolderForm kmaction="new"/> },
      { path: 'edytujkatalog/:folderId', element: <FolderForm kmaction="edit"/> },
      { path: 'edytujkatalog/:folderId/:siblingDocumentId', element: <FolderForm kmaction="edit"/> },
      { path: 'edytujkatalog/:folderId/:siblingDocumentId/:siblingDocumentName', element: <FolderForm kmaction="edit"/> },
      { path: 'przenieskatalogdokument/:parentFolderId', element: <MoveForm/> },
      { path: 'uzytkownicy', element: <UsersView /> },
      { path: 'uzytkownicy/nowyuzytk', element: <UserForm kmaction="new"/> },
      { path: 'uzytkownicy/edytujuzytk/:entryId', element: <UserForm kmaction="edit"/> },
      { path: 'uzytkownicy/edytujuzytk/:entryId/:sortCol/:sortDir/:rowsPerPage/:page', element: <UserForm kmaction="edit"/> },
      { path: 'profile', element: <ProfilesView /> },
      { path: 'profile/nowyprofil', element: <ProfileForm kmaction="new"/> },
      { path: 'profile/edytujprofil/:entryId', element: <ProfileForm  kmaction="edit"/> },
      { path: 'administracja/slowniki', element: <DictionairesView /> },
      { path: 'administracja/slowniki/:tabId', element: <DictionairesView /> },
      { path: 'administracja/slowniki/nowareprstr', element: <SideRepresentedForm  kmaction="new"/> },
      { path: 'administracja/slowniki/edytujreprstr/:entryId', element: <SideRepresentedForm  kmaction="edit"/> },
      { path: 'administracja/slowniki/nowainst', element: <InstytutionForm  kmaction="new"/> },
      { path: 'administracja/slowniki/edytujinst/:entryId', element: <InstytutionForm  kmaction="edit"/> },
      { path: 'administracja/slowniki/nowafunk', element: <FunctionForm  kmaction="new"/> },
      { path: 'administracja/slowniki/edytujfunk/:entryId', element: <FunctionForm  kmaction="edit"/> },
      { path: 'administracja/slowniki/nowagruparob', element: <WorkingGroupForm  kmaction="new"/> },
      { path: 'administracja/slowniki/edytujgruparob/:entryId', element: <WorkingGroupForm  kmaction="edit"/> },
      { path: 'administracja/slowniki/nowywariantodp', element: <AnswerOptionForm  kmaction="new"/> },
      { path: 'administracja/slowniki/edytujwariantodp/:entryId', element: <AnswerOptionForm  kmaction="edit"/> },
      { path: 'administracja/slowniki/nowytypwiad', element: <MessageTypeForm kmaction="new"/> },
      { path: 'administracja/slowniki/edytujtypwiad/:entryId', element: <MessageTypeForm  kmaction="edit"/> },
      { path: 'administracja/sekretariatkm', element: <EmailConfigurationForm /> },
      { path: 'administracja/zdarzenia', element: <EventLogView /> },
      { path: 'administracja/nieuprawnionydostep', element: <IllegalAccess /> },
      { path: 'administracja/zalogowaniuzytkownicy', element: <LoggedInUsers /> },
      { path: 'zarzadzanieglosowania', element: <VotingsPreparingView /> },
      { path: 'zarzadzanieglosowania/wprzygotowaniu', element: <VotingsPreparingView /> },
      { path: 'zarzadzanieglosowania/wtrakcie', element: <VotingsInProgressView/> },
      { path: 'zarzadzanieglosowania/zakonczone', element: <VotingsFinishedView /> },
      { path: 'zarzadzanieglosowania/anulowane', element: <VotingsCanceledView /> },
      { path: 'zarzadzanieglosowania/noweglosowanie', element: <VotingManagementForm kmaction="new"/> },
      { path: 'zarzadzanieglosowania/edycjaglosowania/:entryId', element: <VotingManagementForm kmaction="edit"/> },
      { path: 'zarzadzanieglosowania/podgladglosowania/:entryId', element: <VotingManagementPreviewForm /> },
      { path: 'zarzadzanieglosowania/podgladglosowania/:entryId/:viewId', element: <VotingManagementPreviewForm /> },
      { path: 'zarzadzanieglosowania/edycjaglosu/:entryId', element: <VotingManagementVoteForm /> },
      { path: 'pomoc/pliki', element: <HelpView /> },
      { path: 'pomoc/kontakt', element: <ContactForm /> },
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'logowanie', element: <LoginView /> },
      { path: 'logowanie/:passwordChangeKey', element: <LoginView /> },
      { path: 'licencja', element: <LicenceView /> },
      { path: 'politykabezp', element: <PolicyView /> },
      { path: 'deklaracjazadaniacz', element: <DeclarationTasksView kmcontext="member"/> },
      { path: 'deklaracjazadaniaobs', element: <DeclarationTasksView kmcontext="observer"/> },
      { path: 'deklaracjadostepnosc', element: <AccessibilityDeclaration /> },
      { path: 'nieuprawnionydostep', element: <NotAccessView /> },
      { path: 'aktywacjahasla/:activationKey', element: <PassActivationView /> },
      { path: 'potwierdzenia/udzial/:confirmationKey', element: <ConfirmAttendanceLink action="participation"/> },
      { path: 'potwierdzenia/brakudzialu/:confirmationKey', element: <ConfirmAttendanceLink action="no_participation"/> },
      { path: '*', element: <NotFoundView /> }
    ]
  }
];